import { messagesEN } from '../locales/messages_EN';
import { messagesIrl } from '../locales/messages_IRL';
const JA_LOCALIZATION_IRL = JSON.parse(process.env.VUE_APP_JA_LOCALIZATION_IRL);
const currencySymbol =
	JA_LOCALIZATION_IRL == true
		? messagesIrl.currencySymbol
		: messagesEN.currencySymbol;
export const debounce = (fn, delay) => {
	let timerId;
	return (...args) => {
		if (timerId) {
			clearTimeout(timerId);
		}
		timerId = setTimeout(() => {
			fn(...args);
			timerId = null;
		}, delay);
	};
};

export const throttle = (fn, delay) => {
	let lastCall = 0;
	return (...args) => {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
};

export const isObject = data => {
	return typeof data == 'object' && data !== null;
};

export const generateUUID = () => {
	var dt = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
		c
	) {
		var r = (dt + Math.random() * 16) % 16 | 0;
		dt = Math.floor(dt / 16);
		return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});
	return uuid;
};

/**
 * Remove single quotes, double quotes and brackets from a string
 *
 * @param string value
 * @returns string
 */
export const escapeString = value => {
	return typeof value === 'string' ? value.replace(/['"();\\]+/g, '') : value;
};

/**
 * Validate if File contains more than given MaxLines
 *
 * @param File file
 * @param Number maxLines
 */
export const validateFileMaxLines = (file, maxLines) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsText(file);
		reader.onload = event => {
			const result = event.target.result.replace(/\n\s/g, '').split('\n');

			if (result.length <= maxLines - 1) {
				resolve({ fileLines: result.length - 1 });
			}
			reject({ maxLinesError: true });
		};

		reader.onerror = error => reject(error);
	});
};

/**
 * Get Date as UTC format
 * If no date is passed returns UTC from "today"
 *
 * @param string date - the date that should be formatted
 */
export const convertUTCtoDateTime = date => {
	const theDate = date ? new Date(date) : new Date();
	const utc = [];
	utc.push(theDate.getUTCFullYear());
	// Add one because JS counts month from 0 - January
	// But backend need the month +1 (January = 1)
	utc.push(theDate.getUTCMonth() + 1);
	utc.push(theDate.getUTCDate());
	utc.push(theDate.getUTCHours());
	utc.push(theDate.getUTCMinutes());
	utc.push(theDate.getUTCSeconds());
	utc.push(theDate.getUTCMilliseconds());

	return utc.join(',');
};

/**
 * Get Date or Datetime to UTC
 * If no date is passes return UTC from "Today"
 *
 * @param String date
 * @param Boolean asObject
 */
export const convertDateTimeToUTC = (date, asObject) => {
	const theDate = date ? new Date(date) : new Date();
	const convertedDate = new Date(
		Date.UTC(
			theDate.getUTCFullYear(),
			theDate.getUTCMonth(),
			theDate.getUTCDate(),
			theDate.getUTCHours(),
			theDate.getUTCMinutes(),
			theDate.getUTCSeconds(),
			theDate.getUTCMilliseconds()
		)
	);

	if (asObject) {
		return convertedDate;
	}

	return convertedDate.toISOString();
};

/**
 * Returns a string in format ${number}/${number} or -/- based
 * on the given values
 *
 * @param {Number} value
 * @param {Number} outOfValue
 * @returns {String}
 */
export const formatPricePears = (value, outOfValue) => {
	const current = value ? `${currencySymbol}${value}` : '-';
	const final = outOfValue ? `${currencySymbol}${outOfValue}` : '-';

	return `${current}/${final}`;
};

/**
 * Add minutes to given date
 *
 * @param {Date} date
 * @param {Integer} minutes
 * @returns {Date}
 */
export const addMinutesToDate = (date, minutes) => {
	return new Date(date.getTime() + minutes * 60000);
};

export const isNumber = value => {
	return typeof value === 'number';
};

export const getObjectFromArray = (arr, key, needle) => {
	return arr.find(i => i[key] === needle);
};

export const removeMetaFields = object => {
	const filteredObject = {};

	Object.keys(object).forEach(key => {
		if (key.includes('__')) {
			return;
		}

		filteredObject[key] = object[key];
	});

	return filteredObject;
};

export const createDownloadLink = (href, fileName, target = null) => {
	const link = document.createElement('a');
	link.href = href;
	link.download = fileName;

	if (target) {
		link.target = target;
	}

	return link;
};

export const createLinkForDownload = (href, fileName) => {
	const link = createDownloadLink(href, fileName);
	link.click();
};

export const downloadCsvFile = (csvStr, fileName) => {
	const href = 'data:text/csv;charset=utf-8,' + encodeURI(csvStr);
	const target = '_blank';
	const link = createDownloadLink(href, fileName, target);
	link.click();
};
